package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.error.ValidationError
import fr.manyverse.app.domain.model.InventoryItem
import fr.manyverse.app.domain.repository.InventoryRepository

class TransferInventoryItemUseCase(
    private val inventoryRepository: InventoryRepository
) {
    suspend operator fun invoke(
        item: InventoryItem,
        toCharacterId: String,
        quantity: Int
    ): Result<Unit> {
        if (quantity < 1 || quantity > item.quantity) {
            return Result.failure(ValidationError("Invalid quantity"))
        }

        return inventoryRepository.transferItem(item.id, toCharacterId, quantity)
    }
}
